import { EEnvironment } from '~/entities';
import { BaseUrlController } from '../base-client/base-url-controller';
import { getInstallId } from '~/shared/helpers/getInstallId';
import { getOSVersion } from '~/shared/helpers/getOSVersion';
import { getReleaseVersion } from '~/shared/helpers/getAppVersion';

const baseUrlController = new BaseUrlController({
  baseUrlEnvKey: 'VITE_APP_API_BASE_URL_MAGNIT_ID',
});

baseUrlController.add(EEnvironment.RELEASE, 'https://id.uat.platform.md.magnit.ru/v1');
baseUrlController.add(EEnvironment.DEVELOPMENT, 'https://id.dev.ya.magnit.ru/v1');
baseUrlController.add(EEnvironment.PRODUCTION, 'https://id.magnit.ru/v1');

export class MagnitIdConfig {
  public DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
    'X-Device-ID': getInstallId(),
    'X-Platform-Version': getOSVersion(),
    'X-Device-Platform': 'Web',
    'X-App-Version': getReleaseVersion(),
  };

  public aud = 'market-web';

  public getBaseUrl() {
    return baseUrlController.getBaseUrl();
  }
}
